export const ClientSkillSuggestionStatus={
    NOT_STARTED: 0,
    IN_PROGRESS: 1,
    COMPLETED:2
}